/**
 * English Quote Translations
 * 报价弹窗翻译模块 - 英语
 * 
 * 包含获取报价表单和弹窗等翻译
 */

import type { QuoteTranslations } from '../../types';

export const enQuote: QuoteTranslations = {
  getQuote: 'Get a Quote',
  title: 'Get a Free Quote',
  modal: {
    title: 'Get a Free Quote',
    subtitle: 'Fill out the details below and our team will get back to you within 24 hours.',
    fullName: 'Full Name',
    email: 'Email',
    phone: 'Phone',
    productInterest: 'Product Interest',
    message: 'Message',
    placeholderName: 'John Doe',
    placeholderEmail: 'john@example.com',
    placeholderPhone: '+1 (555) 000-0000',
    placeholderProduct: 'e.g., Industrial Heater',
    placeholderMessage: 'Project details, quantity, voltage requirements...',
    submit: 'Submit Request',
    successTitle: 'Request Received!',
    successMessage: 'Thank you for your interest. One of our heating specialists will review your requirements and contact you shortly.',
    close: 'Close',
  },
  name: 'Your Name',
  email: 'Email Address',
  phone: 'Phone Number',
  company: 'Company Name',
  message: 'Message',
  submit: 'Submit Request',
  success: 'Thank you! We will contact you soon.',
};
